import { createSlice, current } from '@reduxjs/toolkit'

const projectList = createSlice({
    name: 'projectList',
    initialState: {
        list: [],
        listLoaded: [],
        listObject: [],
        listObjectLoaded: [],
        listUser: [],
        listUserLoaded: []
    },
    reducers: {
        load(state, action) {
            const id_status = action.payload.id_status;
            state.list = [...state.list.filter(a => a.ID_Status !== id_status), ...action.payload.list];
            state.listLoaded = [...state.listLoaded.filter(a => a.id_status !== id_status), { id_status: id_status }];
        },
        loadObject(state, action) {
            const id_status = action.payload.id_status;
            state.listObject = [...state.listObject.filter(a => a.id_status !== id_status), ...action.payload.list.map((item) => { return { ...item, id_status: id_status } })];
            state.listObjectLoaded = [...state.listObjectLoaded.filter(a => a.id_status !== id_status), { id_status: id_status }];
        },
        loadUser(state, action) {
            const id_status = action.payload.id_status;
            state.listUser = [...state.listUser.filter(a => a.id_status !== id_status), ...action.payload.list.map((item) => { return { ...item, id_status: id_status } })];
            state.listUserLoaded = [...state.listUserLoaded.filter(a => a.id_status !== id_status), { id_status: id_status }];
        },
        update(state, action) {
            const model = action.payload.model;
            const listObject = action.payload.listObject;
            const listUser = action.payload.listUser;

            /*const list_new = current(state.list).map(item => {
                if (item.ID === model.ID) {
                    return model;
                }
                else {
                    return item;
                }
            })*/
            state.list = [...state.list.filter(a => a.ID !== model.ID), model];
            //state.list = list_new;


            state.listObject = [...state.listObject.filter(a => a.ID_Project !== model.ID), ...listObject];
            state.listUser = [...state.listUser.filter(a => a.ID_Project !== model.ID), ...listUser];
        },
        remove(state, action) {
            const id_project = action.payload.id_project;
            state.list = [...state.list.filter(a => a.ID !== id_project)];
            state.listObject = [...state.listObject.filter(a => a.ID_Project !== id_project)];
            state.listUser = [...state.listUser.filter(a => a.ID_Project !== id_project)];
        }
    }
})

export const { load, loadObject, loadUser, update, remove } = projectList.actions
export default projectList.reducer